import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { LeapBotInline } from '../../shared/utils/leapbot-markdown.util';

/**
 * Renders the inline pieces of a parsed LeapBot answer with plain Angular bindings (never
 * `innerHTML`). Links are always `https://` (the parser drops every other scheme) and open in a
 * new tab without giving the page access to Fury.
 */
@Component({
  selector: 'nf-leapbot-inlines',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (inline of inlines(); track $index) {
      @switch (inline.kind) {
        @case ('bold') {
          <strong>{{ inline.text }}</strong>
        }
        @case ('italic') {
          <em>{{ inline.text }}</em>
        }
        @case ('code') {
          <code class="rounded bg-sk-surface-sunken px-1 py-0.5 text-[0.85em]">{{ inline.text }}</code>
        }
        @case ('link') {
          <a
            class="text-sk-primary underline"
            [href]="inline.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{ inline.text }}</a
          >
        }
        @default {
          {{ inline.text }}
        }
      }
    }
  `,
})
export class NfLeapBotInlinesComponent {
  /** Inline pieces to render. */
  readonly inlines = input.required<LeapBotInline[]>();
}
